/** Test-only switches read from the address, honoured only where the debug tools are (never on the public game). */
export function parseDripWeeks(search: string, debug: boolean): number | undefined {
  if (!debug) return undefined;
  const raw = new URLSearchParams(search).get("drip");
  if (raw === null || !/^\d{1,2}$/.test(raw)) return undefined;
  const n = Number(raw);
  return n >= 0 && n <= 52 ? n : undefined;
}
